import {
    SET_FIELD_VALUE,
    SET_TRANSFER_LOADING,
    SET_TRANSFER_MESSAGE,
    SET_TRANSFER_ERRORS,
    RESET_INITIAL_TRANSFER_STATE,
    RESET_TRANSFER_MESSAGE,
    RESET_AND_SET_TYPE,
    SET_UPLOAD_CONFIG
} from './ConfigurationsTransferConstants';

const initialState = {
    transferType: 'rap',
    sourceRaid: '',
    sourceInstanceId: '',
    destRaid: '',
    destinationSN: '',
    loading: false,
    status: null,
    message: '',
    errors: {},
    allowedFileTypes: null,
    maxFileSizeGB: null
};

const ConfigurationsTransferReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FIELD_VALUE:
            return { ...state, [action.newState.field]: action.newState.value };
        case SET_TRANSFER_LOADING:
            return { ...state, loading: action.newState.loading };
        case SET_TRANSFER_MESSAGE:
            return { ...state, status: action.newState.status, message: action.newState.message };
        case SET_TRANSFER_ERRORS:
            return { ...state, errors: action.newState.errors };
        case RESET_TRANSFER_MESSAGE:
            return { ...state, status: null, message: '' };
        case RESET_INITIAL_TRANSFER_STATE:
            return { ...initialState, allowedFileTypes: state.allowedFileTypes, maxFileSizeGB: state.maxFileSizeGB };
        case RESET_AND_SET_TYPE:
            return { ...initialState, transferType: action.newState.transferType, allowedFileTypes: state.allowedFileTypes, maxFileSizeGB: state.maxFileSizeGB };
        case SET_UPLOAD_CONFIG:
            return { ...state, allowedFileTypes: action.newState.allowedFileTypes, maxFileSizeGB: action.newState.maxFileSizeGB };
        default:
            return state;
    }
};

export default ConfigurationsTransferReducer;
